import apiClient from '@/services/AccountClient'

export default {
  fetchAllTransactionalFees (params = {}, options) {
    const defaultSort = 'updatedAt,desc'

    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/fees/transactional',
      {
        ...params,
        sort: [].concat(params.sort, defaultSort)
      },
      options
    )
  },
  fetchAllRecurringFees (params = {}, options) {
    const defaultSort = 'updatedAt,desc'

    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/fees/recurring',
      {
        ...params,
        sort: [].concat(params.sort, defaultSort)
      },
      options
    )
  },
  fetchTransactionalFee (id) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/fees/transactional/${id}`
    )
  },
  fetchRecurringFee (id) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/fees/recurring/${id}`
    )
  },
  createTransactionalFee (data) {
    return apiClient.sendRequest(
      'POST',
      'api/admin/v1/fees/transactional',
      data
    )
  },
  updateTransactionalFee (id, data) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/fees/transactional/${id}`,
      data
    )
  },
  updateRecurringFee (id, data) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/fees/recurring/${id}`,
      data
    )
  },
  calculateTransactionalFee (data, options) {
    return apiClient.sendRequest(
      'POST',
      'api/admin/v1/fees/transactional/calculator',
      data,
      options
    )
  },
  createRecurringFee (data) {
    return apiClient.sendRequest(
      'POST',
      'api/admin/v1/fees/recurring',
      data
    )
  },
  calculateForexFee (data, options) {
    return apiClient.sendRequest(
      'POST',
      'api/admin/v1/fees/forex/calculator',
      data,
      options
    )
  },
  fetchAllFeeGroups (params = {}, options) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/fees/groups',
      params,
      options
    )
  },
  fetchFeeGroup (feeGroupId, params) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/fees/groups/${feeGroupId}`,
      params
    )
  },
  createFeeGroup (data) {
    return apiClient.sendRequest(
      'POST',
      'api/admin/v1/fees/groups',
      data
    )
  },
  updateFeeGroup (feeGroupId, data) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/fees/groups/${feeGroupId}`,
      data
    )
  },
  fetchReportIdentifiers () {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/fees/report-identifiers'
    )
  }
}
